export const NAVIGATION_ONBOARDING = 'onboarding'
export const NAVIGATION_OVERVIEW = 'overview'
export const NAVIGATION_ORDERS = 'orders'
export const NAVIGATION_BILLING = 'billing'
export const NAVIGATION_REPORTS = 'reports'
export const NAVIGATION_SHIPMENT_TRACKER = 'shipment-tracker'
export const NAVIGATION_E_INVOICES = 'e-invoices'
